import { jsx as r } from "react/jsx-runtime";
import { withManagedProps as a } from "@made-people/managed-props";
import { withZod as m } from "@made-people/react-prop-guard";
import { LogoCardSchema as e, LogoCard as n } from "@made-people/blueprint-logo-card";
import { swiperPropsSchema as s, Swiper as h } from "@made-people/blueprint-swiper";
const l = s.omit({
  children: !0
}), c = l.extend({
  items: e.array().optional(),
  cardVariants: e.shape.variants.optional()
}), f = a(
  "SwipeableLogos",
  m(c, (o) => !o.items || o.items.length === 0 ? null : /* @__PURE__ */ r(h, { ...o, children: (o.items ?? []).map((i, t) => /* @__PURE__ */ r(
    n,
    {
      ...i,
      variants: o.cardVariants
    },
    `logo-item-${t}`
  )) }))
);
export {
  f as SwipeableLogos,
  c as swipeableLogosSchema
};
//# sourceMappingURL=index.es.js.map
